import type { SxProps, Theme } from './types';

export const interactiveHoverSurfaceBackground = 'var(--surface-hover)';

export const interactiveHoverSurfaceSx = {
  '&:hover, &.Mui-focusVisible, &:active': {
    backgroundColor: interactiveHoverSurfaceBackground,
  },
} satisfies SxProps<Theme>;
